<template>
  <div class="pb-3" style="min-height: 200px">
    <div v-if="loading" class="text-xs-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-if="!loading && transactionData && transactionData.length > 0">
      <v-expansion-panel>
        <template v-for="(item, index) in transactionData">
          <v-expansion-panel-content :key="index">
            <template #actions>
              <v-icon color="primary">$vuetify.icons.expand</v-icon>
            </template>
            <template #header>
              <v-layout wrap>
                <v-flex xs6>
                  <div>{{ item.action }}</div>
                  <div class="caption">{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</div>
                </v-flex>
                <v-flex xs3 style="display: flex; align-items: center">
                  <span :class="item.update_point > 0 ? 'green--text' : 'red--text'">{{
                    item.update_point > 0 ? '+' : ''
                  }}</span>
                  <span :class="item.update_point > 0 ? 'green--text' : 'red--text'">{{
                    item.update_point | numberFormat
                  }}</span>
                </v-flex>
                <v-flex xs3 style="display: flex; align-items: center">
                  <span>{{ item.point | numberFormat }}</span>
                </v-flex>
              </v-layout>
            </template>
            <v-card>
              <v-card-text class="grey lighten-3">
                <div>{{ getNote(item.note) }}</div></v-card-text
              >
            </v-card>
          </v-expansion-panel-content>
        </template>
      </v-expansion-panel>
      <div class="pt-3">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pagelength"
          @input="changePage"
        ></v-pagination>
      </div>
    </template>
    <template v-if="!loading && transactionData.length == 0">
      <div class="text-xs-center pt-5">- ไม่มีรายการเดินคะแนนสะสม -</div>
    </template>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import { mapGetters } from 'vuex'

export default {
  props: ['value'],
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      transactionData: [],
      loading: false
    }
  },
  mounted() {
    this.handleGetTransactionPoint()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    async handleGetTransactionPoint() {
      const vm = this
      try {
        const memberId = vm.value
        const data = {
          pageId: vm.selectedBot.pageid,
          memberId: memberId,
          params: {
            limit: vm.limit,
            offset: vm.offset
          }
        }

        vm.loading = true
        const response = await toaCrmApi.getTransactionPoint({ config: data })
        vm.loading = false

        if (response && response.status === 200) {
          vm.transactionData = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    getNote(item) {
      let tempNote = ''
      if (item) {
        const obj = JSON.parse(item)
        const foundKey = Object.keys(obj)

        if ([...foundKey].includes('camapignName')) {
          tempNote = `ชื่อแคมเปญ: ${obj.camapignName}`
        } else if ([...foundKey].includes('data')) {
          tempNote = `เลขที่ใบเสร็จ: ${obj.data[0].ref_no}`
        } else if ([...foundKey].includes('ref_no')) {
          tempNote = `เลขที่ใบเสร็จ: ${obj.ref_no}`
        } else if ([...foundKey].includes('type') && obj.type === 'manual') {
          tempNote = obj.text
        } else {
          tempNote = `ของรางวัล: ${obj.name}`
        }
      }
      return tempNote
    },
    isShowDetails(action) {
      let status = false

      if (action === 'คะแนนสะสมพิเศษ' || action === 'แลกของรางวัล') {
        status = true
      }
      return status
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp !== val) {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.handleGetTransactionPoint()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/RedeemPointHistory.vue